module.exports = __webpack_public_path__ + "img/profile-edit.c385d5cf.svg";